import React from 'react';

export default function SoulBalmLogo({ size = 80, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Head circle */}
      <circle cx="100" cy="42" r="16" stroke="#D4AF37" strokeWidth="4" fill="none" />
      {/* Body circle with flame */}
      <circle cx="100" cy="90" r="28" stroke="#D4AF37" strokeWidth="4" fill="none" />
      {/* Flame/leaf inside */}
      <path
        d="M100 72 C96 80, 92 88, 100 100 C108 88, 104 80, 100 72Z"
        stroke="#D4AF37"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      {/* Lotus petals */}
      <path
        d="M48 155 C60 120, 85 108, 100 118 C115 108, 140 120, 152 155"
        stroke="#D4AF37"
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M100 118 C80 130, 55 148, 40 165"
        stroke="#D4AF37"
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M100 118 C120 130, 145 148, 160 165"
        stroke="#D4AF37"
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
